import { storage } from '@/utils/storage';

export const useCacheData = () => {
  const localCache = ({ cacheKey, expire = 60 * 30, defaultData, dataApi, params = {}, formatData, dataProcessing }) => {
    if (!cacheKey || !dataApi || !dataProcessing) return
    let cache_data = storage.get(cacheKey, '', () => {
      // 缓存已过期 去服务器获取新数据 更新缓存
      dataApi(params).then(res => {
        let data = res.data || defaultData;
        if (formatData) {
          data = formatData(data);
        }
        dataProcessing(data);
        storage.set(cacheKey, JSON.stringify(data), expire)
      });
    })

    if (cache_data) {
      // 有缓存数据  直接使用缓存数据渲染
      let data = JSON.parse(cache_data);
      dataProcessing(data)
      return Promise.resolve();
    } else { // 没有缓存数据  去服务器获取数据 并缓存
      return dataApi(params).then(res => {
        let data = res.data || defaultData;
        if (formatData) {
          data = formatData(data);
        }
        dataProcessing(data);
        storage.set(cacheKey, JSON.stringify(data), expire)
      });
    }
  }

  return {
    localCache,
  }
}